"use client";
import { Doc } from "@/convex/_generated/dataModel";
import { identify as identifyMixpanel } from "./mixpanel";
import { identify as identifySentry } from "./sentry";

const identify = async (user: Doc<"users">) => {
    try {
        await identifyMixpanel(user._id);
    } catch (error) {
        // noop
    }

    try {
        await identifySentry(user);
    } catch (error) {
        // noop
    }
};

export { identify };
